import React, {Component, Fragment} from 'react';
import {Button, Card, CardHeader, CardTitle, Form, FormGroup, Input, Label, Row} from "reactstrap";
import CommonInput from "../common/common-input";
import Select from "react-select";
import Col from "reactstrap/lib/Col";
import {connect} from "react-redux";
import {
    actionGetAgents, actionGetPermissions,
    actionGetRole,
    actionGetSingleRoleDetails,
    actionGetUserById,
    actionUpdateUserById
} from "../../actions/profile";
import {logoutAdmin, register} from "../../actions/auth";
import {ADMIN} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import SelectBoxListLoader from "../Permission/selectBoxListLoader";
import DataNotFound from "../common/DataNotFound";
import HeroSection from "../common/HerroSection/hero-section";
import {Link} from "react-router-dom";
import image from "../../assets/img/Logo/1.png";
import CommanSidebar from '../common/commanSidebar'

class AddUpdateUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: '',
            mobile: '',
            password: '',
            permission: [],

            errors: {}
        }
    }

    componentDidMount() {
        this.props.actionGetRole();
        this.props.actionGetPermissions();

        if (this.props.match.params.id) {
            this.props.actionGetUserById(this.props.match.params.id)
        }

    }

    componentDidUpdate(prevProps, prevState) {
        prevProps.singlUser !== this.props.singlUser && this.setState({
            name: this.props.singlUser.name,
            email: this.props.singlUser.email,
            mobile: this.props.singlUser.mobile,
            password: this.props.singlUser.password,
            role: this.props.singlUser.role._id,
            permission: this.props.singlUser.permissions && this.props.singlUser.permissions
        });

        if (prevProps.singleRoleDetails !== this.props.singleRoleDetails) {
            ((this.props.singleRoleDetails && this.props.singleRoleDetails.permissions) && this.props.singleRoleDetails.permissions.length > 0) && this.setState({
                permission: this.props.singleRoleDetails.permissions
            });
        }
    }


    handleSaveValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

        if (!fields.name) {
            formIsValid = false;
            errors.name = "Please Enter Name...!";
        }
        if (!fields.email) {
            formIsValid = false;
            errors.email = "Please Enter Email...!";
        } else if (!validEmailRegex.test(fields.email)) {
            formIsValid = false;
            errors.email = "Please Enter Valid Email...!";
        }
        if (!fields.role) {
            formIsValid = false;
            errors.role = "Please Select Role ..!";
        }
        if (!fields.mobile) {
            formIsValid = false;
            errors.mobile = "Please Enter Mobile No. ..!";
        }
        if (!fields.password && !this.props.match.params.id) {
            formIsValid = false;
            errors.password = "Please Enter Password. ..!";
        }

        this.setState({errors: errors});
        return formIsValid;

    };

    onSaveSubmit = e => {
        e.preventDefault();
        if (this.handleSaveValidation()) {
            if (this.props.match.params.id) {
                const {name, email, role, mobile, permission} = this.state;
                const request = {
                    name,
                    email,
                    role: this.props.role && this.props.role.find(f => f._id === role)._id,
                    mobile,
                    refId: this.props.user._id,
                    permissions: permission
                };
                console.log({request});
                this.props.actionUpdateUserById(this.props.match.params.id, request, this.props.history)
            }
            else {
                const {name, email, role, mobile, password, permission} = this.state;
                const request = {
                    name,
                    email,
                    mobile,
                    password,
                    role: this.props.role && this.props.role.find(f => f._id === role).name,
                    refId: this.props.user._id,
                    permissions: permission,
                    type: 'ADD_USER'

                };
                console.log({request});
                this.props.register(request, this.props.history)
            }

        }
    };

    handleSelectPermission = e => this.state.permission.filter(p => p === e.target.value).length ?
        this.setState({permission: [...this.state.permission.filter(p => p !== e.target.value)]})
        :
        this.setState({permission: [...this.state.permission, e.target.value]});

    onChange = e => this.setState({[e.target.name]: e.target.value});

    render() {
        const {errors, permission} = this.state;
        const {permissions, permissionLoader, roleLoader,} = this.props;

        const RoleOptions = (this.props.role && this.props.role.length > 0) && this.props.role.map(c => ({
            value: c._id,
            label: c.name,
        }));
        return (
            <Fragment>
                <CommanSidebar/>
                <div className="content">
                    <div className="row">
                        <div className="col-md-10 mx-auto mt-5">
                            <Form className="card p-3 d-flex" autoComplete="off" noValidate={true}
                                  onSubmit={this.onSaveSubmit}>
                                <h3 className="text-center mb-2">{this.props.match.params.id ? "UPDATE USER" : 'ADD USER'}</h3>
                                <Row className="cards" style={{width: "100%"}} autoComplete="off" noValidate={true}>
                                    <CommonInput
                                        lbl={'Name:'}
                                        name={'name'}
                                        type={'text'}
                                        value={this.state.name}
                                        onChange={this.onChange}
                                        errors={errors.name}
                                        place={'Enter Name'}
                                    />

                                    <CommonInput
                                        lbl={'Mobile:'}
                                        name={'mobile'}
                                        type={'number'}
                                        value={this.state.mobile}
                                        onChange={this.onChange}
                                        errors={errors.mobile}
                                        place={'Enter Mobile'}
                                    />
                                    {
                                        <Col lg={12} xl={12}>
                                            <FormGroup>
                                                <Label>Role</Label>
                                                <Select
                                                    name="role"
                                                    value={RoleOptions && RoleOptions.find(item => item.value === this.state.role)}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            role: e.value,
                                                        });
                                                        this.props.actionGetSingleRoleDetails(e.value)
                                                    }}
                                                    options={RoleOptions}
                                                />
                                                <span className="text-danger">{errors.role}</span>
                                            </FormGroup>
                                        </Col>

                                    }
                                    <CommonInput
                                        lbl={'Email:'}
                                        name={'email'}
                                        type={'email'}
                                        value={this.state.email}
                                        onChange={this.onChange}
                                        errors={errors.email}
                                        place={'Enter Email'}
                                    />
                                    {
                                        this.props.match.params.id ? ''
                                            :
                                            <CommonInput
                                                lbl={'Password:'}
                                                name={'password'}
                                                type={'password'}
                                                value={this.state.password}
                                                onChange={this.onChange}
                                                errors={errors.password}
                                                place={'Enter Password'}
                                            />
                                    }


                                    {/*<Col lg={12} xl={12}>*/}
                                    {/*<Label className="font-weight-normal">Permission:</Label>*/}
                                    {/*</Col>*/}

                                    {/*{((!permissionLoader || !roleLoader) && permissions && permissions.length > 0) ? permissions.map((data, index) =>*/}
                                    {/*<div className="row col-12 px-5" key={index}>*/}
                                    {/*<div*/}
                                    {/*className="form-check d-flex align-items-center cursor-pointer py-1 ">*/}
                                    {/*<input className="form-check-input cursor-pointer" type="checkbox"*/}
                                    {/*onChange={this.handleSelectPermission} value={data._id}*/}
                                    {/*id={data._id}*/}
                                    {/*checked={permission.find(d => d === data._id)}/>*/}
                                    {/*<label className="form-check-label h6 cursor-pointer"*/}
                                    {/*htmlFor={data._id}>*/}
                                    {/*{data.name}*/}
                                    {/*</label>*/}
                                    {/*</div>*/}
                                    {/*</div>*/}
                                    {/*) : (roleLoader && permissionLoader) ?*/}
                                    {/*<Fragment>*/}
                                    {/*<SelectBoxListLoader/>*/}
                                    {/*<SelectBoxListLoader/>*/}
                                    {/*<SelectBoxListLoader/>*/}
                                    {/*<SelectBoxListLoader/>*/}
                                    {/*</Fragment> :*/}
                                    {/*<DataNotFound message={"Not Found"}/>}*/}

                                    <div className="col-12 rounded mt-3">
                                        <Button type="submit">Save</Button>
                                    </div>

                                </Row>
                            </Form>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    singlUser: state.profile.singlUser,
    role: state.profile.role,
    roleLoader: state.profile.roleLoader,
    singleRoleDetails: state.profile.singleRoleDetails,
    permissions: state.profile.permissions,
    permissionLoader: state.profile.permissionLoader,
    user: state.auth.user
});


export default connect(mapStateToProps, {
    actionGetRole,
    register,
    actionGetUserById,
    actionUpdateUserById,
    actionGetSingleRoleDetails,
    actionGetPermissions,
    logoutAdmin
})(AddUpdateUsers);

